import { Box, Stack } from "@mui/material";
import cbhLogoPath from "@src/appV2/lib/assets/images/cbh-logo-horizontal.png";
import sweaterImagePath from "@src/appV2/lib/assets/images/holiday-gift/sweater.png";
import { Image, Text } from "@src/appV2/redesign/system/ui-components";

export function HolidayGiftShareScreen() {
  return (
    <Box
      id="holiday-gift-share-screen"
      sx={{
        alignItems: "center",
        justifyContent: "center",
        background:
          // eslint-disable-next-line cbh-rules/no-inline-gradient -- TODO: migrate to theme palette gradient
          "linear-gradient(180deg, rgba(251, 242, 232, 1) 0%, rgba(218, 241, 232, 1) 100%)",
      }}
    >
      <Stack spacing={10} padding={6} alignItems="center" justifyContent="center">
        <Stack spacing={7} paddingTop={10} alignItems="center" justifyContent="center">
          <Box paddingX={6} width="80%">
            <Image
              src={sweaterImagePath}
              alt="Free Sweater"
              borderRadius="25px"
              boxShadow="0 4px 4px 0 rgba(0, 0, 0, 0.25)"
              flex={1}
              width="100%"
            />
          </Box>

          <Text variant="h2" textAlign="center" px={6}>
            I got a free FIGS fleece jacket!
          </Text>

          <Text variant="h4" textAlign="center">
            I earned this by reaching 1,000 Clipboard Score this year. That’s the top 1% of
            professionals!
          </Text>
          <Image src={cbhLogoPath} alt="Clipboard Logo" width="30%" />
        </Stack>
      </Stack>
    </Box>
  );
}
